import type { User, Restaurant, Category, MenuItem, Order, Coupon } from '../App';

// Demo users for different roles
export const DEMO_USERS: User[] = [
  {
    id: '1',
    email: 'superadmin@foodhub.com',
    name: 'Super Admin',
    role: 'superadmin',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=superadmin',
    isActive: true
  },
  {
    id: '2',
    email: 'admin@spicekitchen.com',
    name: 'Rajesh Kumar',
    role: 'restaurant_admin',
    restaurantId: '1',
    phone: '+91 98765 43210',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=rajesh',
    isActive: true
  },
  {
    id: '3',
    email: 'manager@spicekitchen.com',
    name: 'Priya Sharma',
    role: 'manager',
    restaurantId: '1',
    phone: '+91 98765 43211',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=priya',
    isActive: true
  },
  {
    id: '4',
    email: 'staff@spicekitchen.com',
    name: 'Amit Patel',
    role: 'staff',
    restaurantId: '1',
    phone: '+91 98765 43212',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=amit',
    isActive: true
  },
  {
    id: '5',
    email: 'customer@example.com',
    name: 'Neha Verma',
    role: 'customer',
    phone: '+91 98765 43213',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=neha',
    isActive: true
  },
  {
    id: '6',
    email: 'admin@pizzapalace.com',
    name: 'Marco Rossi',
    role: 'restaurant_admin',
    restaurantId: '2',
    phone: '+91 98765 43214',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=marco',
    isActive: true
  }
];

export const DEMO_RESTAURANTS: Restaurant[] = [
  {
    id: '1',
    name: 'Spice Kitchen',
    description: 'Authentic Indian cuisine with a modern twist',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=spicekitchen',
    banner: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=1200',
    address: '123 MG Road, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 1234 5678',
    email: 'contact@spicekitchen.com',
    primaryColor: '#E23744',
    secondaryColor: '#FFF5F5',
    isActive: true,
    rating: 4.5,
    totalOrders: 2847,
    totalRatings: 1243,
    cuisine: ['Indian', 'North Indian', 'Mughlai'],
    openTime: '11:00',
    closeTime: '23:00',
    deliveryTime: '30-40 mins',
    minimumOrder: 200,
    deliveryFee: 40,
    freeDeliveryAbove: 500,
    taxRate: 5,
    packagingCharges: 20,
    distance: 2.5,
    isPureVeg: false,
    isOpen: true,
    hasOffers: true,
    amenities: ['wifi', 'parking', 'ac']
  },
  {
    id: '2',
    name: 'Pizza Palace',
    description: 'Wood-fired authentic Italian pizzas',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=pizzapalace',
    banner: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200',
    address: '456 Brigade Road, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 2345 6789',
    email: 'contact@pizzapalace.com',
    primaryColor: '#FF6B35',
    secondaryColor: '#FFF8F3',
    isActive: true,
    rating: 4.3,
    totalOrders: 1923,
    totalRatings: 876,
    cuisine: ['Italian', 'Pizza', 'Pasta'],
    openTime: '12:00',
    closeTime: '00:00',
    deliveryTime: '25-35 mins',
    minimumOrder: 300,
    deliveryFee: 50,
    freeDeliveryAbove: 600,
    taxRate: 5,
    packagingCharges: 25,
    distance: 4.2,
    isPureVeg: false,
    isOpen: true,
    hasOffers: false,
    amenities: ['ac', 'parking']
  },
  {
    id: '3',
    name: 'Sushi Express',
    description: 'Fresh Japanese sushi and sashimi',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=sushiexpress',
    banner: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=1200',
    address: '789 Indiranagar, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 3456 7890',
    email: 'contact@sushiexpress.com',
    primaryColor: '#2D3142',
    secondaryColor: '#F8F9FA',
    isActive: false,
    rating: 4.7,
    totalOrders: 856,
    totalRatings: 412,
    cuisine: ['Japanese', 'Sushi', 'Asian'],
    openTime: '13:00',
    closeTime: '22:30',
    deliveryTime: '40-50 mins',
    minimumOrder: 500,
    deliveryFee: 60,
    freeDeliveryAbove: 800,
    taxRate: 5,
    packagingCharges: 30,
    distance: 6.8,
    isPureVeg: false,
    isOpen: false,
    hasOffers: true,
    amenities: ['wifi', 'ac']
  },
  {
    id: '4',
    name: 'Green Leaf',
    description: 'Pure vegetarian health-focused meals',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=greenleaf',
    banner: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=1200',
    address: '321 Koramangala, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 4567 8901',
    email: 'contact@greenleaf.com',
    primaryColor: '#4CAF50',
    secondaryColor: '#F1F8E9',
    isActive: true,
    rating: 4.6,
    totalOrders: 1654,
    totalRatings: 723,
    cuisine: ['Indian', 'South Indian', 'Healthy'],
    openTime: '08:00',
    closeTime: '22:00',
    deliveryTime: '20-30 mins',
    minimumOrder: 150,
    deliveryFee: 30,
    freeDeliveryAbove: 400,
    taxRate: 5,
    packagingCharges: 15,
    distance: 1.8,
    isPureVeg: true,
    isOpen: true,
    hasOffers: true,
    amenities: ['wifi', 'parking', 'ac']
  },
  {
    id: '5',
    name: 'Burger Bliss',
    description: 'Gourmet burgers and loaded fries',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=burgerbliss',
    banner: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=1200',
    address: '654 HSR Layout, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 5678 9012',
    email: 'contact@burgerbliss.com',
    primaryColor: '#FF9800',
    secondaryColor: '#FFF3E0',
    isActive: true,
    rating: 4.4,
    totalOrders: 3210,
    totalRatings: 1567,
    cuisine: ['American', 'Fast Food', 'Burgers'],
    openTime: '11:00',
    closeTime: '23:30',
    deliveryTime: '25-35 mins',
    minimumOrder: 250,
    deliveryFee: 45,
    freeDeliveryAbove: 550,
    taxRate: 5,
    packagingCharges: 20,
    distance: 3.5,
    isPureVeg: false,
    isOpen: true,
    hasOffers: true,
    amenities: ['parking', 'ac']
  },
  {
    id: '6',
    name: 'Wok & Roll',
    description: 'Asian street food and noodles',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=wokandroll',
    banner: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=1200',
    address: '987 Whitefield, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 6789 0123',
    email: 'contact@wokandroll.com',
    primaryColor: '#D32F2F',
    secondaryColor: '#FFEBEE',
    isActive: true,
    rating: 4.2,
    totalOrders: 1432,
    totalRatings: 645,
    cuisine: ['Chinese', 'Asian', 'Thai'],
    openTime: '12:00',
    closeTime: '23:00',
    deliveryTime: '35-45 mins',
    minimumOrder: 280,
    deliveryFee: 55,
    freeDeliveryAbove: 650,
    taxRate: 5,
    packagingCharges: 22,
    distance: 7.2,
    isPureVeg: false,
    isOpen: true,
    hasOffers: false,
    amenities: ['wifi', 'ac']
  },
  {
    id: '7',
    name: 'Cafe Aroma',
    description: 'Cozy cafe with artisanal coffee and fresh pastries',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=cafearoma',
    banner: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=1200',
    address: '145 Church Street, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 7890 1234',
    email: 'contact@cafearoma.com',
    primaryColor: '#6F4E37',
    secondaryColor: '#F5F5DC',
    isActive: true,
    rating: 4.5,
    totalOrders: 987,
    totalRatings: 523,
    cuisine: ['Cafe', 'Coffee', 'Continental'],
    openTime: '08:00',
    closeTime: '23:00',
    deliveryTime: '20-30 mins',
    minimumOrder: 180,
    deliveryFee: 35,
    freeDeliveryAbove: 350,
    taxRate: 5,
    packagingCharges: 18,
    distance: 3.2,
    isPureVeg: true,
    isOpen: true,
    hasOffers: true,
    amenities: ['wifi', 'parking', 'ac', 'outdoor-seating']
  },
  {
    id: '8',
    name: 'Biryani House',
    description: 'Hyderabadi dum biryani and authentic Awadhi cuisine',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=biryanihouse',
    banner: 'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=1200',
    address: '234 Residency Road, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 8901 2345',
    email: 'contact@biryanihouse.com',
    primaryColor: '#8B4513',
    secondaryColor: '#FFF8DC',
    isActive: true,
    rating: 4.6,
    totalOrders: 2456,
    totalRatings: 1156,
    cuisine: ['Biryani', 'Hyderabadi', 'Mughlai'],
    openTime: '11:30',
    closeTime: '23:30',
    deliveryTime: '35-45 mins',
    minimumOrder: 250,
    deliveryFee: 45,
    freeDeliveryAbove: 500,
    taxRate: 5,
    packagingCharges: 20,
    distance: 4.5,
    isPureVeg: false,
    isOpen: true,
    hasOffers: true,
    amenities: ['parking', 'ac']
  },
  {
    id: '9',
    name: 'The Rooftop Lounge',
    description: 'Premium dining with live music and skyline views',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=rooftoplounge',
    banner: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1200',
    address: '567 UB City, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 9012 3456',
    email: 'contact@rooftoplounge.com',
    primaryColor: '#1F1F1F',
    secondaryColor: '#F5F5F5',
    isActive: true,
    rating: 4.8,
    totalOrders: 534,
    totalRatings: 298,
    cuisine: ['Continental', 'Multi-cuisine', 'Bar'],
    openTime: '18:00',
    closeTime: '01:00',
    deliveryTime: 'Dine-in only',
    minimumOrder: 1000,
    deliveryFee: 0,
    freeDeliveryAbove: 0,
    taxRate: 5,
    packagingCharges: 0,
    distance: 5.8,
    isPureVeg: false,
    isOpen: true,
    hasOffers: false,
    amenities: ['wifi', 'parking', 'ac', 'live-music', 'rooftop', 'bar']
  },
  {
    id: '10',
    name: 'Taco Fiesta',
    description: 'Authentic Mexican street food and margaritas',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=tacofiesta',
    banner: 'https://images.unsplash.com/photo-1565299507177-b0ac66763828?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1565299507177-b0ac66763828?w=1200',
    address: '890 Commercial Street, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 0123 4567',
    email: 'contact@tacofiesta.com',
    primaryColor: '#FF6347',
    secondaryColor: '#FFFACD',
    isActive: true,
    rating: 4.3,
    totalOrders: 1234,
    totalRatings: 567,
    cuisine: ['Mexican', 'Latin American', 'Fast Food'],
    openTime: '12:00',
    closeTime: '23:00',
    deliveryTime: '25-35 mins',
    minimumOrder: 220,
    deliveryFee: 40,
    freeDeliveryAbove: 450,
    taxRate: 5,
    packagingCharges: 18,
    distance: 2.8,
    isPureVeg: false,
    isOpen: true,
    hasOffers: true,
    amenities: ['ac', 'outdoor-seating']
  },
  {
    id: '11',
    name: 'South Spice',
    description: 'Traditional South Indian tiffin and filter coffee',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=southspice',
    banner: 'https://images.unsplash.com/photo-1630383249896-424e482df921?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1630383249896-424e482df921?w=1200',
    address: '123 Jayanagar, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 1234 0987',
    email: 'contact@southspice.com',
    primaryColor: '#FF4500',
    secondaryColor: '#FFFAF0',
    isActive: true,
    rating: 4.7,
    totalOrders: 3456,
    totalRatings: 1678,
    cuisine: ['South Indian', 'Breakfast', 'Tiffin'],
    openTime: '07:00',
    closeTime: '22:00',
    deliveryTime: '20-30 mins',
    minimumOrder: 120,
    deliveryFee: 25,
    freeDeliveryAbove: 300,
    taxRate: 5,
    packagingCharges: 12,
    distance: 1.5,
    isPureVeg: true,
    isOpen: true,
    hasOffers: true,
    amenities: ['wifi', 'parking', 'ac']
  },
  {
    id: '12',
    name: 'BBQ Nation',
    description: 'Unlimited grills and buffet experience',
    logo: 'https://api.dicebear.com/7.x/shapes/svg?seed=bbqnation',
    banner: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1200',
    coverImage: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1200',
    address: '456 Forum Mall, Bangalore',
    city: 'Bangalore',
    phone: '+91 80 2345 0987',
    email: 'contact@bbqnation.com',
    primaryColor: '#8B0000',
    secondaryColor: '#FFE4E1',
    isActive: true,
    rating: 4.4,
    totalOrders: 876,
    totalRatings: 445,
    cuisine: ['BBQ', 'Grills', 'Multi-cuisine'],
    openTime: '12:00',
    closeTime: '23:30',
    deliveryTime: 'Dine-in only',
    minimumOrder: 800,
    deliveryFee: 0,
    freeDeliveryAbove: 0,
    taxRate: 5,
    packagingCharges: 0,
    distance: 6.5,
    isPureVeg: false,
    isOpen: true,
    hasOffers: true,
    amenities: ['wifi', 'parking', 'ac', 'buffet']
  }
];

export const DEMO_CATEGORIES: Category[] = [
  { id: '1', restaurantId: '1', name: 'Starters', order: 1, isActive: true },
  { id: '2', restaurantId: '1', name: 'Main Course', order: 2, isActive: true },
  { id: '3', restaurantId: '1', name: 'Breads', order: 3, isActive: true },
  { id: '4', restaurantId: '1', name: 'Desserts', order: 4, isActive: true },
  { id: '5', restaurantId: '1', name: 'Beverages', order: 5, isActive: true },
  { id: '6', restaurantId: '2', name: 'Pizzas', order: 1, isActive: true },
  { id: '7', restaurantId: '2', name: 'Pasta', order: 2, isActive: true },
  { id: '8', restaurantId: '2', name: 'Sides', order: 3, isActive: true }
];

export const DEMO_MENU_ITEMS: MenuItem[] = [
  {
    id: '1',
    restaurantId: '1',
    categoryId: '1',
    name: 'Paneer Tikka',
    description: 'Cottage cheese marinated in spices and grilled to perfection',
    price: 280,
    image: 'https://images.unsplash.com/photo-1567188040759-fb8a883dc6d8?w=400',
    tags: ['veg', 'bestseller', 'recommended'],
    spicyLevel: 2,
    isActive: true,
    preparationTime: 15,
    inStock: true,
    variants: [
      { id: 'v1', name: 'Half', price: 280, isDefault: true },
      { id: 'v2', name: 'Full', price: 480 }
    ],
    addOns: [
      { id: 'a1', name: 'Extra Spicy', price: 0, category: 'Spice Level' },
      { id: 'a2', name: 'Mild Spice', price: 0, category: 'Spice Level' },
      { id: 'a3', name: 'Extra Mint Chutney', price: 20, category: 'Extras' },
      { id: 'a4', name: 'Extra Onions', price: 15, category: 'Extras' }
    ]
  },
  {
    id: '2',
    restaurantId: '1',
    categoryId: '1',
    name: 'Chicken Tikka',
    description: 'Tender chicken pieces marinated in yogurt and spices',
    price: 320,
    image: 'https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400',
    tags: ['non-veg', 'bestseller'],
    spicyLevel: 2,
    isActive: true,
    preparationTime: 20,
    inStock: true,
    variants: [
      { id: 'v1', name: 'Half (6 pcs)', price: 320, isDefault: true },
      { id: 'v2', name: 'Full (12 pcs)', price: 550 }
    ],
    addOns: [
      { id: 'a1', name: 'Extra Spicy', price: 0, category: 'Spice Level' },
      { id: 'a2', name: 'Mild Spice', price: 0, category: 'Spice Level' },
      { id: 'a3', name: 'Extra Mint Chutney', price: 20, category: 'Extras' },
      { id: 'a4', name: 'Lemon Wedges', price: 10, category: 'Extras' }
    ]
  },
  {
    id: '3',
    restaurantId: '1',
    categoryId: '2',
    name: 'Butter Chicken',
    description: 'Creamy tomato-based curry with tender chicken pieces',
    price: 380,
    image: 'https://images.unsplash.com/photo-1603894584373-5ac82b2ae398?w=400',
    tags: ['non-veg', 'chef-special', 'bestseller'],
    spicyLevel: 1,
    isActive: true,
    preparationTime: 25,
    inStock: true,
    variants: [
      { id: 'v1', name: 'Half', price: 380, isDefault: true },
      { id: 'v2', name: 'Full', price: 650 }
    ],
    addOns: [
      { id: 'a1', name: 'Extra Gravy', price: 50, category: 'Extras' },
      { id: 'a2', name: 'Less Creamy', price: 0, category: 'Preparation' },
      { id: 'a3', name: 'Extra Butter', price: 30, category: 'Extras' }
    ]
  },
  {
    id: '4',
    restaurantId: '1',
    categoryId: '2',
    name: 'Paneer Butter Masala',
    description: 'Rich and creamy curry with cottage cheese cubes',
    price: 320,
    image: 'https://images.unsplash.com/photo-1631452180519-c014fe946bc7?w=400',
    tags: ['veg', 'bestseller'],
    spicyLevel: 1,
    isActive: true,
    preparationTime: 20,
    inStock: true,
    variants: [
      { id: 'v1', name: 'Half', price: 320, isDefault: true },
      { id: 'v2', name: 'Full', price: 550 }
    ],
    addOns: [
      { id: 'a1', name: 'Extra Paneer', price: 80, category: 'Extras' },
      { id: 'a2', name: 'Extra Gravy', price: 50, category: 'Extras' },
      { id: 'a3', name: 'Less Spicy', price: 0, category: 'Spice Level' }
    ]
  },
  {
    id: '5',
    restaurantId: '1',
    categoryId: '2',
    name: 'Dal Makhani',
    description: 'Black lentils slow-cooked with butter and cream',
    price: 260,
    image: 'https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400',
    tags: ['veg', 'recommended'],
    spicyLevel: 1,
    isActive: true,
    preparationTime: 15,
    inStock: true,
    variants: [
      { id: 'v1', name: 'Half', price: 260, isDefault: true },
      { id: 'v2', name: 'Full', price: 450 }
    ],
    addOns: [
      { id: 'a1', name: 'Extra Cream', price: 30, category: 'Extras' },
      { id: 'a2', name: 'Tadka on Side', price: 20, category: 'Preparation' }
    ]
  },
  {
    id: '6',
    restaurantId: '1',
    categoryId: '3',
    name: 'Butter Naan',
    description: 'Soft leavened bread brushed with butter',
    price: 50,
    tags: ['veg'],
    spicyLevel: 0,
    isActive: true,
    preparationTime: 10,
    inStock: true,
    addOns: [
      { id: 'a1', name: 'Extra Butter', price: 10, category: 'Extras' },
      { id: 'a2', name: 'No Butter', price: -10, category: 'Preparation' }
    ]
  },
  {
    id: '7',
    restaurantId: '1',
    categoryId: '3',
    name: 'Garlic Naan',
    description: 'Naan topped with fresh garlic and cilantro',
    price: 60,
    tags: ['veg', 'recommended'],
    spicyLevel: 0,
    isActive: true,
    preparationTime: 10,
    inStock: true,
    addOns: [
      { id: 'a1', name: 'Extra Garlic', price: 15, category: 'Extras' },
      { id: 'a2', name: 'Extra Butter', price: 10, category: 'Extras' },
      { id: 'a3', name: 'Cheese Stuffed', price: 40, category: 'Extras' }
    ]
  },
  {
    id: '8',
    restaurantId: '1',
    categoryId: '4',
    name: 'Gulab Jamun',
    description: 'Soft milk dumplings in rose-flavored sugar syrup',
    price: 120,
    image: 'https://images.unsplash.com/photo-1590301157890-4810ed352733?w=400',
    tags: ['veg', 'seasonal'],
    spicyLevel: 0,
    isActive: true,
    preparationTime: 5,
    inStock: true,
    variants: [
      { id: 'v1', name: '2 pieces', price: 120, isDefault: true },
      { id: 'v2', name: '4 pieces', price: 220 }
    ],
    addOns: [
      { id: 'a1', name: 'Warm', price: 0, category: 'Preparation' },
      { id: 'a2', name: 'Extra Syrup', price: 20, category: 'Extras' },
      { id: 'a3', name: 'With Ice Cream', price: 60, category: 'Extras' }
    ]
  },
  {
    id: '9',
    restaurantId: '2',
    categoryId: '6',
    name: 'Margherita Pizza',
    description: 'Classic pizza with tomato sauce, mozzarella, and basil',
    price: 450,
    image: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400',
    tags: ['veg', 'bestseller'],
    spicyLevel: 0,
    isActive: true,
    preparationTime: 20,
    inStock: true,
    variants: [
      { id: 'v1', name: 'Regular (9")', price: 450, isDefault: true },
      { id: 'v2', name: 'Medium (12")', price: 650 },
      { id: 'v3', name: 'Large (15")', price: 850 }
    ],
    addOns: [
      { id: 'a1', name: 'Extra Cheese', price: 60, category: 'Toppings' },
      { id: 'a2', name: 'Extra Basil', price: 20, category: 'Toppings' },
      { id: 'a3', name: 'Chilli Flakes', price: 0, category: 'Extras' },
      { id: 'a4', name: 'Oregano', price: 0, category: 'Extras' },
      { id: 'a5', name: 'Thin Crust', price: 0, category: 'Crust' },
      { id: 'a6', name: 'Cheese Burst Crust', price: 100, category: 'Crust' }
    ]
  },
  {
    id: '10',
    restaurantId: '2',
    categoryId: '6',
    name: 'Pepperoni Pizza',
    description: 'Loaded with pepperoni and mozzarella cheese',
    price: 550,
    image: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400',
    tags: ['non-veg', 'bestseller'],
    spicyLevel: 1,
    isActive: true,
    preparationTime: 20,
    inStock: true,
    variants: [
      { id: 'v1', name: 'Regular (9")', price: 550, isDefault: true },
      { id: 'v2', name: 'Medium (12")', price: 750 },
      { id: 'v3', name: 'Large (15")', price: 950 }
    ],
    addOns: [
      { id: 'a1', name: 'Extra Pepperoni', price: 80, category: 'Toppings' },
      { id: 'a2', name: 'Extra Cheese', price: 60, category: 'Toppings' },
      { id: 'a3', name: 'Jalapeños', price: 40, category: 'Toppings' },
      { id: 'a4', name: 'Cheese Burst Crust', price: 100, category: 'Crust' },
      { id: 'a5', name: 'Thin Crust', price: 0, category: 'Crust' }
    ]
  }
];

export const DEMO_ORDERS: Order[] = [
  {
    id: 'ORD001',
    restaurantId: '1',
    customerId: '5',
    customerName: 'Neha Verma',
    customerPhone: '+91 98765 43213',
    customerAddress: '12/A, Koramangala 4th Block, Bangalore - 560034',
    items: [
      { menuItemId: '3', name: 'Butter Chicken', price: 380, quantity: 1 },
      { menuItemId: '6', name: 'Butter Naan', price: 50, quantity: 2 }
    ],
    subtotal: 480,
    deliveryFee: 40,
    packagingCharges: 20,
    tax: 24,
    discount: 0,
    total: 564,
    status: 'preparing',
    paymentMethod: 'upi',
    paymentStatus: 'paid',
    createdAt: new Date(Date.now() - 20 * 60000).toISOString(),
    updatedAt: new Date(Date.now() - 10 * 60000).toISOString(),
    estimatedDelivery: new Date(Date.now() + 20 * 60000).toISOString(),
    assignedTo: '4',
    notes: 'Please make it less spicy'
  },
  {
    id: 'ORD002',
    restaurantId: '1',
    customerId: '5',
    customerName: 'Rahul Singh',
    customerPhone: '+91 98765 43220',
    customerAddress: '45/B, HSR Layout, Bangalore - 560102',
    items: [
      { menuItemId: '1', name: 'Paneer Tikka', price: 280, quantity: 1 },
      { menuItemId: '4', name: 'Paneer Butter Masala', price: 320, quantity: 1 },
      { menuItemId: '7', name: 'Garlic Naan', price: 60, quantity: 3 }
    ],
    subtotal: 780,
    deliveryFee: 0,
    packagingCharges: 20,
    tax: 39,
    discount: 78,
    couponCode: 'WELCOME10',
    total: 761,
    status: 'confirmed',
    paymentMethod: 'card',
    paymentStatus: 'paid',
    createdAt: new Date(Date.now() - 5 * 60000).toISOString(),
    updatedAt: new Date(Date.now() - 3 * 60000).toISOString(),
    estimatedDelivery: new Date(Date.now() + 35 * 60000).toISOString()
  },
  {
    id: 'ORD003',
    restaurantId: '1',
    customerId: '5',
    customerName: 'Anita Desai',
    customerPhone: '+91 98765 43221',
    customerAddress: '78/C, Whitefield, Bangalore - 560066',
    items: [
      { menuItemId: '2', name: 'Chicken Tikka', price: 320, quantity: 2 },
      { menuItemId: '8', name: 'Gulab Jamun', price: 120, quantity: 1 }
    ],
    subtotal: 760,
    deliveryFee: 40,
    packagingCharges: 20,
    tax: 38,
    discount: 0,
    total: 858,
    status: 'pending',
    paymentMethod: 'cash',
    paymentStatus: 'pending',
    createdAt: new Date(Date.now() - 2 * 60000).toISOString(),
    updatedAt: new Date(Date.now() - 2 * 60000).toISOString(),
    estimatedDelivery: new Date(Date.now() + 40 * 60000).toISOString()
  },
  {
    id: 'ORD004',
    restaurantId: '1',
    customerId: '5',
    customerName: 'Vikram Malhotra',
    customerPhone: '+91 98765 43222',
    customerAddress: '23/D, Indiranagar, Bangalore - 560038',
    items: [
      { menuItemId: '5', name: 'Dal Makhani', price: 260, quantity: 1 },
      { menuItemId: '6', name: 'Butter Naan', price: 50, quantity: 4 }
    ],
    subtotal: 460,
    deliveryFee: 40,
    packagingCharges: 20,
    tax: 23,
    discount: 0,
    total: 543,
    status: 'out_for_delivery',
    paymentMethod: 'upi',
    paymentStatus: 'paid',
    createdAt: new Date(Date.now() - 45 * 60000).toISOString(),
    updatedAt: new Date(Date.now() - 5 * 60000).toISOString(),
    estimatedDelivery: new Date(Date.now() + 10 * 60000).toISOString(),
    assignedTo: '4'
  }
];

export const DEMO_COUPONS: Coupon[] = [
  {
    id: '1',
    restaurantId: '1',
    code: 'WELCOME10',
    description: '10% off on orders above ₹300',
    discountType: 'percentage',
    discountValue: 10,
    minOrderValue: 300,
    maxDiscount: 100,
    isActive: true,
    validFrom: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
    usageLimit: 1000,
    usedCount: 234
  },
  {
    id: '2',
    restaurantId: '1',
    code: 'FLAT50',
    description: 'Flat ₹50 off on orders above ₹400',
    discountType: 'flat',
    discountValue: 50,
    minOrderValue: 400,
    isActive: true,
    validFrom: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
    validUntil: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000).toISOString(),
    usageLimit: 500,
    usedCount: 123
  },
  {
    id: '3',
    restaurantId: '1',
    code: 'FEAST20',
    description: '20% off on orders above ₹500',
    discountType: 'percentage',
    discountValue: 20,
    minOrderValue: 500,
    maxDiscount: 200,
    isActive: true,
    validFrom: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    validUntil: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
    usedCount: 45
  },
  {
    id: '4',
    restaurantId: '2',
    code: 'PIZZA25',
    description: '25% off on orders above ₹600',
    discountType: 'percentage',
    discountValue: 25,
    minOrderValue: 600,
    maxDiscount: 150,
    isActive: true,
    validFrom: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000).toISOString(),
    validUntil: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000).toISOString(),
    usageLimit: 300,
    usedCount: 89
  }
];

// Initialize data in localStorage if not exists
export function initializeMockData() {
  if (!localStorage.getItem('restaurants')) {
    localStorage.setItem('restaurants', JSON.stringify(DEMO_RESTAURANTS));
  }
  if (!localStorage.getItem('categories')) {
    localStorage.setItem('categories', JSON.stringify(DEMO_CATEGORIES));
  }
  if (!localStorage.getItem('menuItems')) {
    localStorage.setItem('menuItems', JSON.stringify(DEMO_MENU_ITEMS));
  }
  if (!localStorage.getItem('orders')) {
    localStorage.setItem('orders', JSON.stringify(DEMO_ORDERS));
  }
  if (!localStorage.getItem('users')) {
    localStorage.setItem('users', JSON.stringify(DEMO_USERS));
  }
  if (!localStorage.getItem('coupons')) {
    localStorage.setItem('coupons', JSON.stringify(DEMO_COUPONS));
  }
}

// Helper functions to get data
export function getRestaurants(): Restaurant[] {
  const data = localStorage.getItem('restaurants');
  return data ? JSON.parse(data) : DEMO_RESTAURANTS;
}

export function getCategories(restaurantId?: string): Category[] {
  const data = localStorage.getItem('categories');
  const categories = data ? JSON.parse(data) : DEMO_CATEGORIES;
  return restaurantId 
    ? categories.filter((c: Category) => c.restaurantId === restaurantId)
    : categories;
}

export function getMenuItems(restaurantId?: string): MenuItem[] {
  const data = localStorage.getItem('menuItems');
  const items = data ? JSON.parse(data) : DEMO_MENU_ITEMS;
  return restaurantId 
    ? items.filter((i: MenuItem) => i.restaurantId === restaurantId)
    : items;
}

export function getOrders(restaurantId?: string): Order[] {
  const data = localStorage.getItem('orders');
  const orders = data ? JSON.parse(data) : DEMO_ORDERS;
  return restaurantId 
    ? orders.filter((o: Order) => o.restaurantId === restaurantId)
    : orders;
}

export function getUsers(): User[] {
  const data = localStorage.getItem('users');
  return data ? JSON.parse(data) : DEMO_USERS;
}

export function getStaff(restaurantId?: string): User[] {
  const users = getUsers();
  return restaurantId
    ? users.filter(u => u.restaurantId === restaurantId && (u.role === 'manager' || u.role === 'staff'))
    : users.filter(u => u.role === 'manager' || u.role === 'staff');
}

export function getCoupons(restaurantId?: string): Coupon[] {
  const data = localStorage.getItem('coupons');
  const coupons = data ? JSON.parse(data) : DEMO_COUPONS;
  return restaurantId 
    ? coupons.filter((c: Coupon) => c.restaurantId === restaurantId)
    : coupons;
}

export function validateCoupon(code: string, restaurantId: string, orderValue: number): { valid: boolean; coupon?: Coupon; message?: string } {
  const coupons = getCoupons(restaurantId);
  const coupon = coupons.find(c => c.code === code && c.isActive);
  
  if (!coupon) {
    return { valid: false, message: 'Invalid coupon code' };
  }
  
  const now = new Date();
  if (new Date(coupon.validFrom) > now) {
    return { valid: false, message: 'Coupon not yet valid' };
  }
  
  if (new Date(coupon.validUntil) < now) {
    return { valid: false, message: 'Coupon has expired' };
  }
  
  if (coupon.usageLimit && coupon.usedCount >= coupon.usageLimit) {
    return { valid: false, message: 'Coupon usage limit reached' };
  }
  
  if (orderValue < coupon.minOrderValue) {
    return { valid: false, message: `Minimum order value is ₹${coupon.minOrderValue}` };
  }
  
  return { valid: true, coupon };
}

export function calculateDiscount(coupon: Coupon, orderValue: number): number {
  if (coupon.discountType === 'flat') {
    return coupon.discountValue;
  } else {
    const discount = (orderValue * coupon.discountValue) / 100;
    return coupon.maxDiscount ? Math.min(discount, coupon.maxDiscount) : discount;
  }
}